import { Button } from '@blueprintjs/core';
import { Error } from '@hogwarts/ui-components-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const RenderNotFound = () => {
  const navigate = useNavigate();
  return (
    <Error
      title="Oops! Page Not Found"
      action={
        <Button onClick={() => navigate('/')} intent="primary">
          Dashboard
        </Button>
      }
    />
  );
};

export default RenderNotFound;
